import React, { useState } from 'react';
import Button from './ui/Button';
import './WelcomeTour.css';

/**
 * #239 — Micro-tour de boas-vindas (4 passos).
 *
 * Mostrado 1× na primeira sessão (flag localStorage), sempre pulável. Em vez de
 * exigir a leitura do tutorial longo, apresenta o fluxo em 4 passos honestos:
 * registrar → IA analisa → você revisa → exporta. Autocontido: checa o
 * localStorage e decide se aparece — o App só renderiza <WelcomeTour/>.
 *
 * Aditivo, zero gating. Copy não-enganar: descreve só o que o sistema faz de
 * fato (a IA é ponto de partida; o humano decide — posicionamento copiloto).
 */
const TOUR_KEY = 'qaasa_tour_visto';

const PASSOS = [
  {
    icon: 'edit_note',
    titulo: 'Registre o problema',
    texto: 'Descreva a não conformidade em linguagem simples — o que aconteceu, onde e como foi detectado. Sem formulário intimidante.',
  },
  {
    icon: 'auto_awesome',
    titulo: 'A IA analisa',
    texto: 'Em segundos, a Qaa.sa monta a análise no método ISO 9001: Ishikawa 6M, 5 porquês, causa raiz e um plano de ação 5W2H — sem o trabalho manual.',
  },
  {
    icon: 'edit',
    titulo: 'Você revisa e decide',
    texto: 'A IA é o ponto de partida, não a palavra final. Edite a causa, ajuste as ações, refine o que precisar — você tem o controle, e tudo fica registrado.',
  },
  {
    icon: 'picture_as_pdf',
    titulo: 'Exporte o relatório',
    texto: 'Baixe o PDF pronto para auditoria, com a trilha do que foi feito. Da ocorrência ao relatório, em minutos.',
  },
];

function WelcomeTour({ onNovaNC }) {
  const [visivel, setVisivel] = useState(() => {
    try { return localStorage.getItem(TOUR_KEY) !== '1'; } catch (e) { return false; }
  });
  const [passo, setPasso] = useState(0);

  if (!visivel) return null;

  const fechar = () => {
    try { localStorage.setItem(TOUR_KEY, '1'); } catch (e) { /* localStorage indisponível — ignora */ }
    setVisivel(false);
  };

  const ultimo = passo === PASSOS.length - 1;
  const p = PASSOS[passo];

  return (
    <div className="welcome-tour-overlay" onClick={fechar} role="dialog" aria-modal="true">
      <div className="welcome-tour-card" onClick={(e) => e.stopPropagation()}>
        <button className="welcome-tour-pular" onClick={fechar}>Pular</button>

        <div className="welcome-tour-icone">
          <span className="material-symbols-outlined">{p.icon}</span>
        </div>
        <div className="welcome-tour-kicker">Passo {passo + 1} de {PASSOS.length}</div>
        <h2 className="welcome-tour-titulo">{p.titulo}</h2>
        <p className="welcome-tour-texto">{p.texto}</p>

        <div className="welcome-tour-dots">
          {PASSOS.map((_, i) => (
            <span key={i} className={`welcome-tour-dot${i === passo ? ' is-ativo' : ''}`} />
          ))}
        </div>

        <div className="welcome-tour-acoes">
          {passo > 0
            ? <Button variant="secondary" onClick={() => setPasso(passo - 1)}>Voltar</Button>
            : <span />}
          {ultimo
            ? <Button icon="add" onClick={() => { fechar(); onNovaNC?.(); }}>Registrar minha primeira NC</Button>
            : <Button icon="arrow_forward" onClick={() => setPasso(passo + 1)}>Próximo</Button>}
        </div>
      </div>
    </div>
  );
}

export default WelcomeTour;
